// extracted by mini-css-extract-plugin
export default {"root":"SignInCountDown_root__rS0W0","time":"SignInCountDown_time__7PO9Y","settingBtn":"SignInCountDown_settingBtn__AWwY+","button":"SignInCountDown_button__Tntmu"};